import React from 'react';
import renderHTML from 'react-render-html';


import {
  StyledWrapper,
  StyledHeader,
  StyledDescription,
} from './cost.style';
import { StyledElementWrapperCenter, StyledElementButton } from 'styledElements';

// Texts
import text from 'i18l';

const Cost = () => (
  <StyledWrapper>
    <StyledElementWrapperCenter>
      <StyledHeader>
        {text.COST.HEADER}
      </StyledHeader>
      <StyledDescription>
        {text.COST.DESCRIPTION}
      </StyledDescription>
      <StyledElementButton to="/oferta-dla-firm">
        {renderHTML(text.COST.BUTTON)}
      </StyledElementButton>
    </StyledElementWrapperCenter>
  </StyledWrapper>
);

export default Cost;


// WEBPACK FOOTER //
// ./src/components/cost/cost.component.js